<template>
    <div>
      <loading v-if="loadingRender"></loading>
      <div class="row">
        <div class="card p-3 m-3 w-100" id="Date">
          <div class="row">
            <span class="alert alert-dark w-100 p-2 m-2 text-center">لطفا پارامترهای خود را انتخاب کرده و سپس گزینه <span class="text-success">جستجو</span> را بزنید </span>
          </div>
          <div class="row">
            <div class="col-md-2 col-12 mt-2 text-right">
              <small> تاریخ تراکنش </small>
              <date-picker :editable="true" :auto-submit="true" color="rgb(94 163 30)" v-model="TarikhAz" input-class="required"> </date-picker>
              <input type="text" tabindex="-1" class="d-none InputText " style="direction: ltr" />
            </div>
            <div class="col-md-4 col-12 mt-2 text-right">
              <small>شماره شبا</small>
              <input type="text" name="name" value="" id="Iban" style="direction: ltr" autocomplete="off" class="form-control required" v-model="Iban" />
            </div>

            <div class="col-md-2 col-12 mt-3">
              <input type="button" name="" value="دریافت اطلاعات" class="btn btn-success mt-2 w-100" @click="Getreport()" />
            </div>
            <div class="col-md-2 col-12 mt-3">
              <ExcelExport 
              :data="exceltable" 
              worksheet-name="Sheet1"
              @success="handleExcelSuccess"
              @error="handleExcelError"
            >
              <button class="btn btn-outline-success d-none">
                <i class="fas fa-file-excel btn btn-outline-success Pointer d-none" id="DownloadExcel"> دانلود فایل اکسل </i>
              </button>
            </ExcelExport>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-1"></div>
            <div class="col-10 text-right">
              <div class="btn-group btn-group-toggle w-100" data-toggle="buttons" tabindex="-1">
                <label tabindex="-1" class="btn Pointer" :class="ravesh == 0 ? 'btn-dark-active' : 'btn-dark'">
                  <input tabindex="-1" @click="FilterData(0)" type="radio" name="options" id="RD1" />
                  - همه تراکنش های موفق درگاه
                </label>
                <label tabindex="-1" class="btn Pointer" :class="ravesh == 1 ? 'btn-dark-active' : 'btn-dark'">
                  <input tabindex="-1" @click="FilterData(1)" type="radio" name="options" id="RD2" />
                  - تراکنش های ناموفق
                </label>
                
              </div>
            </div>
            <div class="col-1"></div>
          </div>
        </div>
      </div>
      <div class="card p-3 m-3 w-100" id="Date2">
        <div class="card mb-2">
          <div class="card-body text-right text-success" style="font-size: 18px">
            <span> مبلغ کل تراکنش : </span>
            <span>
              {{ $Comma3ragham(sumKol) }}
            </span>
          </div>
        </div>
        <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes" :actions="actions" @on-download="Download">
          <template slot="sort-asc-icon">
            <i class="fa fa-sort-up"></i>
          </template>
          <template slot="sort-desc-icon">
            <i class="fa fa-sort-down"></i>
          </template>
          <template slot="no-sort-icon">
            <i class="fa fa-sort"></i>
          </template>
          <template slot="amount" slot-scope="props">
            {{ $Comma3ragham(props.row.amount) }}
          </template>
          <template slot="isVerify" slot-scope="props">
            <span v-if="props.row.isVerify">
              تایید شده
            </span>
            <span v-else>
              تایید نشده
            </span>
          </template>
          <template slot="empty-results">
            <p class="text-right">اطلاعاتی یافت نشد</p>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
  </template>
  <script>
  import VueBootstrap4Table from 'vue-bootstrap4-table'
  import loading from '../Tools/NetPa/Loading.vue'
  
  export default {
    data() {
      return {
        DataAxiosRow: { ArryfildValue: '', Method: 'Post', Action: 'TransactionService', Token: '' },
        TarikhAz: '',
        exceltable: [],
        Iban: '',
        rows: [],
        DATA: [],
        sumKol: 0,
        columns: [
        {
              label: 'id',
              name: 'id',
              visibility: false,
            },
  
            {
              label: 'شماره رهگیری',
              name: 'token',
            },
            {
              label: 'شماره سفارش',
              name: 'orderId',
            },
            {
              label: 'تاریخ ایجاد',
              name: 'zamanInsert',
              sort: true,
              initial_sort: true,
              initial_sort_order: 'desc',
            },
            {
              label: 'مبلغ تراکنش',
              name: 'amount',
            },
            {
              label: 'شماره تعهد',
              name: 'vCodeText',
            },
            {
              label: 'توضیحات',
              name: 'description',
            },
            {
              label: 'وضعیت',
              name: 'isVerify',
            },
        ],
        actions: [
          {
            btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
            event_name: 'on-download',
            class: 'btn  mx-2 btn-outline-success rounded btnEXL ',
            event_payload: { msg: 'my custom msg' },
          },
        ],
        config: {
          pagination: false,
          pagination_info: false,
          per_page_options: [10, 20, 30, 50, 100],
          show_refresh_button: false,
          show_reset_button: false,
          checkbox_rows: false,
          rows_selectable: true,
          card_title: '',
          card_mode: false,
          global_search: {
            placeholder: ' جستجو',
            visibility: true,
            case_sensitive: false,
            showClearButton: true,
            searchOnPressEnter: false,
          },
        },
        classes: {
          table: 'table-bordered table-striped table-sm ',
        },
        loadingRender: false,
        ravesh: 0,
      }
    },
    components: {
      VueBootstrap4Table,
      loading,
    },
    methods: {
            Getreport() {

        if (!this.$ValidForm('Date')) {
          return;
        }
        else{
          this.rows = []
          this.sumKol = 0
          this.loadingRender = true

            let data = {
            "Tarix": this.TarikhAz,
            "Sheba": this.Iban
            };

            
          this.$PostData_new("TransactionService/GetParsian" , "post" ,data,false ).then((res) => {
            this.DATA=res
            //console.log('data' , res);
            
            this.FilterData(0)
          }).finally ((fi)=>{
            this.loadingRender = false
          })
        }
      },
      Download() {
        document.getElementById('DownloadExcel').click()
      },
      exelReport(rows,state) {
        this.exceltable = []
          rows.forEach((element) => {
            var excelrow = {
              'شماره رهگیری': element.token,
              'تاریخ': element.zamanInsert,
              'مبلغ تراکنش': element.amount,
              'شماره تعهد': element.vCodeText,
              'توضیحات': element.description,
              'وضعیت':element.isVerify
            }
  
            this.exceltable.push(excelrow)
          })
        
        
        // console.log( this.exceltable);
      },
      FilterData(id){
        this.ravesh=id
        this.rows=this.DATA
        let dataFilters=id==0 ? this.DATA.filter(x=>x.isVerify==true) : this.DATA.filter(x=>x.isVerify==false);
        //console.log(dataFilters);
        
        if (dataFilters.length > 10) {
          this.config.pagination = true
        } else {
          this.config.pagination = false
        }
        this.sumKol = 0
        let list = []
        for (let index = 0; index < dataFilters.length; index++) {
          let info
          info = dataFilters[index]
          list.push(info)
          this.sumKol += Number.parseInt(dataFilters[index].amount)
        }
        this.loadingRender = false
        this.rows = this.$FormatMablaghGrid(list)
        this.exelReport(this.rows,id)
        if (id == 0) {
          this.columns = [
            {
              label: 'id',
              name: 'id',
              visibility: false,
            },
  
            {
              label: 'شماره رهگیری',
              name: 'token',
            },
            {
              label: 'شماره سفارش',
              name: 'orderId',
            },
            {
              label: 'تاریخ ایجاد',
              name: 'zamanInsert',
              sort: true,
              initial_sort: true,
              initial_sort_order: 'desc',
            },
            {
              label: 'مبلغ تراکنش',
              name: 'amount',
            },
            {
              label: 'شماره تعهد',
              name: 'vCodeText',
            },
            {
              label: 'توضیحات',
              name: 'description',
            },
            {
              label: 'وضعیت',
              name: 'isVerify',
            },
          ]
        } 
        // else {
        //   this.columns = [
        //     {
        //       label: 'شماره رهگیری',
        //       name: 'codeRahgiri',
        //     },
        //     {
        //       label: 'تاریخ سند',
        //       name: 'tarixSanad',
        //       sort: true,
        //       initial_sort: true,
        //       initial_sort_order: 'desc',
        //     },
        //     {
        //       label: 'زمان سند',
        //       name: 'zaman',
        //       sort: true,
        //       initial_sort: true,
        //       initial_sort_order: 'desc',
        //     },
        //     {
        //       label: 'مبلغ تراکنش',
        //       name: 'amount',
        //     },
        //   ]
        // }
        
      }
    },
  }
  </script>
<style scoped>
.btn-dark-active {
  background: #e9b81a;
  color: #000;
}
</style>